import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "./help_hints";
import "./css/wepcg_bar.css"

class LostUnitsBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Invoice Dispute (Missing Goods)</strong></h1>
            <p>
                This claim type is used if the goods invoiced did not arrive at all or are incomplete. Before submitting a dispute please check Order Visibility Portal or with your Customer Fulfillment Representative whether delivery is not still in transit and what is the planned delivery date. If goods arrived but incomplete, please attach Proof of Delivery, it should contain remark of units missing. If it does not please explain in comments why loss could not be detected at the point of delivery. Contact our financial claims team in case there is any question or problem.
            </p>
            <p>
                Claims for lost units must be received by Lenovo no more than fifteen (15) working days after the date of delivery. Please check guideline.
            </p>
            <Help_hints/>
        </div>
    }
}

export default LostUnitsBar;